import * as constants from '../actions/constants'
import { NotificationsActions } from './../actions/notificationActions'
import { INotificationData } from './../types/notification'


export const notifications = (state: INotificationData[] = [], action: NotificationsActions): INotificationData[] => {
  switch (action.type) {
    case constants.GET_NOTIFICATIONS_SUCCESS:
      return action.notifications

    case constants.UPDATE_NOTIFICATION_SUCCESS:

      return state.map(n => {
        if (action.data.includes(n.id)) {
          return { ...n, seen: true}
        }
        return n
      })

    case constants.DELETE_NOTIFICATION_SUCCESS:
      return state.filter(a => a.id !== action.notification.id)

    default:
      return state
  }
}
